/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { CategoryActions } from 'app/redux/actions.js';


function mapStateToProps(state) {
    return({
        categories: state.categories
    });
}

function mapDispatchToProps(dispatch) {

    return {
        getCategories: () => {
            dispatch(CategoryActions.fetchCategories());
        },
        createCategory: (category) => {
            dispatch(CategoryActions.createCategory(category));
        },
        updateCategory: (category) => {
            dispatch(CategoryActions.updateCategory(category));
        },
        deleteCategory: (id) => {
            dispatch(CategoryActions.deleteCategory(id));
        }
	};
}

export default function CategoryProvider(Component) {

    class CategoryProvider extends React.Component {
        render() {
            return (
                <Component {...this.props}/>
            );
        }
    }

    CategoryProvider.displayName = "CategoryProvider";

    return connect(mapStateToProps, mapDispatchToProps)(CategoryProvider);
};
